module.exports = __webpack_public_path__ + "img/icon-close.7d1685ae.svg";